export const USER_LIST = 'USER_LIST';
export const USER_LIST_REGISTER = 'USER_LIST_REGISTER';
export const USER_ACTIVE_REGISTER = 'USER_ACTIVE_REGISTER';
export const USER_LIST_BYDATE = 'USER_LIST_BYDATE';
export const EXPORT_USER = 'EXPORT_USER';
export const USER_INFO = 'USER_INFO';
export const ADMIN_UPDATE_USER = 'ADMIN_UPDATE_USER';
export const GET_TEMP_PASSWORD = 'GET_TEMP_PASSWORD';
export const HARD_DELETE_USER = 'HARD_DELETE_USER';
export const RESYNC_ADDON = 'RESYNC_ADDON';
export const REMOVE_2FA = 'REMOVE_2FA';
export const GET_FORGOTTEN_PASSWORD = 'GET_FORGOTTEN_PASSWORD';
export const ACTIVE_AI_CALL = 'ACTIVE_AI_CALL';
export const DELETE_AI_CALL = 'DELETE_AI_CALL';
export const RESET_DEMO_ACCOUNT = 'RESET_DEMO_ACCOUNT';